export default {
  queryCsAppealDetail: '/gateway/capp/courier_operations/queryCsAppealDetail'
}
